import { useViewHistory, ViewHistoryKey } from '@grandvisionhq/state';

// Re-export the viewHistory API but with the products key used in localStorage bound to it
const useProductViewHistory = useViewHistory.bind(null, ViewHistoryKey.Products);

export { useProductViewHistory };
//# sourceMappingURL=use-product-view-history.js.map
